import React from 'react';
import Image from './image';
import { getDeploymentDomain } from "../utils/common_utils";

class Banner extends React.Component {

    render() {
        const domain = getDeploymentDomain();

        const DOMAIN_CELL_CLASS = {
            "MANUFACTURING":"align-bottom",
            "SUPPLY CHAIN":"align-bottom",
            "VERTICAL":"align-middle",
            "RETAIL":"align-middle"
        };
        const cellExtra = DOMAIN_CELL_CLASS[domain] ? ` ${DOMAIN_CELL_CLASS[domain]}` : "align-middle";
        return (
            <div className="col prelogin-info-col">
                <div className="d-table h-100 w-100">
                    <div className={`d-table-cell ${cellExtra}`}>
                        {domain === "MANUFACTURING" ? (
                            <div className="prelogin-pattern-wrap">
                                <div className="login_intro login_intro-lg prelogin-pattern">
                                    <h1 className='!tw-text-[24px] sm:!tw-text-[24px] md:!tw-text-[32px] xl:!tw-text-[40px] 2xl:!tw-text-[48px]'><Image src="logoLight" className="!tw-max-w-[105px] sm:!tw-max-w-[140px] md:!tw-max-w-[180px] xl:!tw-max-w-[200px]" /> for Manufacturing</h1>
                                    <h4>Detect production data failures before they cost you</h4>
                                    <p className='!tw-max-w-[90%]'>Qualdo™ helps you monitor and resolve critical data issues across production lines, supply inputs, and operational systems—before they cause downtime or defects.</p>
                                </div>
                            </div>
                        ) : domain === "SUPPLY CHAIN" ? (
                            <div className="prelogin-pattern-wrap">
                                <div className="login_intro login_intro-lg prelogin-pattern">
                                    <h1 className='!tw-text-[24px] sm:!tw-text-[24px] md:!tw-text-[32px] xl:!tw-text-[40px] 2xl:!tw-text-[48px]'><Image src="logoLight" className="!tw-max-w-[105px] sm:!tw-max-w-[140px] md:!tw-max-w-[180px] xl:!tw-max-w-[200px]" /> for Supply Chain</h1>
                                    <h4>Keep your supply chain data accurate, end to end</h4>
                                    <p className='!tw-max-w-[90%]'>Qualdo™ helps you identify and fix data errors across inventory, logistics, and vendor systems—before they disrupt fulfillment or forecasting.</p>
                                </div>
                            </div>
                        )
                        : domain === "VERTICAL" ? (
                            <div className="prelogin-pattern-wrap">
                                <div className="login_intro login_intro-lg prelogin-pattern">
                                    <h1 className='!tw-text-[24px] sm:!tw-text-[24px] md:!tw-text-[32px] xl:!tw-text-[40px] 2xl:!tw-text-[48px]'><Image src="logoLight" className="!tw-max-w-[105px] sm:!tw-max-w-[140px] md:!tw-max-w-[180px] xl:!tw-max-w-[200px]" /> for Supply Chain</h1>
                                    <h4>Keep your supply chain data accurate, end to end</h4>
                                    <p className='!tw-max-w-[90%]'>Qualdo™ helps you identify and fix data errors across inventory, logistics, and vendor systems—before they disrupt fulfillment or forecasting.</p>
                                </div>
                            </div>
                        )
                        : (
                            <div className="prelogin-pattern-wrap">
                                <div className="login_intro prelogin-pattern">
                                    <h1 className='!tw-text-[24px] sm:!tw-text-[24px] md:!tw-text-[32px] xl:!tw-text-[40px] 2xl:!tw-text-[48px]'><Image src="logoLight" /> for Retail</h1>
                                    <h4>Resolve critical data issues in minutes</h4>
                                    <p>Qualdo™ helps you spot and fix data errors across sales, inventory, and customer systems—before they impact performance.</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Banner;
